import { SvgProperties } from "csstype";

import * as React from "react";
import styled from "styled-components";

import icons, { Icons } from "../../utils/icons";

import { Theme } from "../../utils/theme";

interface IconWrapperProps {
  hoverColor: keyof Theme["colors"];
  fillColor: keyof Theme["colors"];
}

const IconWrapper = styled.svg<IconWrapperProps>`
  overflow: visible;
  fill: ${({ theme, fillColor }) => theme.colors[fillColor]};
  transition: fill ease-in-out 0.2s;
  :hover {
    cursor: pointer;
    fill: ${({ theme, hoverColor }) => theme.colors[hoverColor]};
  }
`;

const Icon: React.FunctionComponent<IconProps> = ({
  icon,
  size,
  fillColor,
  hoverColor,
  onClick,
  ...rest
}) => {
  if (!icon) {
    return null;
  } else {
    return (
      <>
        <IconWrapper
          onClick={onClick}
          fillColor={fillColor || "fg"}
          hoverColor={hoverColor || fillColor || "accent"}
          width={size || 25}
          height={size || 25}
          viewBox="0 0 100 100"
        >
          <path d={icons[icon]} />
        </IconWrapper>
      </>
    );
  }
};

interface IconProps extends React.HTMLAttributes<SvgProperties> {
  icon?: keyof Icons;
  size?: number;
  fillColor?: keyof Theme["colors"];
  hoverColor?: keyof Theme["colors"];
  onClick?: () => void;
}

export default Icon;
